module.exports = __webpack_public_path__ + "img/icon_map_199_on_011.8d323e94.png";